<div class="mention">
  <div class="d-flex flex-column">
    <label>{{label}}</label>
  </div>
  <achoo-text-field *ngIf="!readOnly"
    [(model)]="currentInputMention"
    [name]="name"
    (keyDownEvent)="mentionInputKeyDown($event)"
    class="input-tag"
    placeholder="{{'campaigns.tag_placeholder' | translate}}"
    #mentionInput
  ></achoo-text-field>
  <div *ngIf="!readOnly" class="chips-gap"></div>
  <achoo-chips *ngIf="mentionKeywords.length > 0"
               [chips]="mentionKeywords"
               [processingChips]="processingMentionKeywords"
               [errorChips]="errorMentions"
               [editable]="!readOnly"
               [material]="true"
               (deleteItem)="confirmationBeforeDeleteMention($event)"
  ></achoo-chips>
  <div class="d-flex flex-row align-items-center country" *ngIf="enableCountry">
    <div class="d-flex flex-g1"><label>{{'discover.search_bar.country_placeholder' | translate}}</label></div>
    <div class="d-flex flex-g7">
      <achoo-filter-box [options]="countryList"
                        name="project_country"
                        class="country-select"
                        [(model)]="countries"
                        multiple="true"
                        placeholder="{{'measure.filters.country_placeholder' | translate}}">
      </achoo-filter-box>
    </div>
  </div>
</div>

<achoo-popup #confirmRemoveMentionDialog
             modelTitle="{{'campaigns.remove_mention.title' | translate}}"
             acceptBtnLabel="{{'campaigns.remove_mention.btn_confirm' | translate}}"
             cancelBtnLabel="{{'campaigns.remove_mention.btn_cancel' | translate}}"
             (acceptCallback)="onDeleteMention()"
             (cancelCallback)="closeConfirmRemoveMentionMessage()">
  <div class="d-flex flex-column flex-auto">
    <span>{{'campaigns.remove_mention.message' | translate: {mention: currentDeleteMention?.keyword} }}</span>
  </div>
</achoo-popup>
<achoo-popup #ErrorWhenAddingNewMention
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}"
             (cancelCallback)="closeConfirmRemoveMentionMessage()">
  <span>{{'common.mention.error_add_new_mention' | translate }}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/core/achoo-keywork-input-field/achoo-keywork-input-field.component.html